/**
 * =============================================================================
 * IMPORTANT, READ THIS MESSAGE BEFORE EDITING THIS FILE.
 *
 * This file needs to be kept tightly in sync with its corresponding version in
 * the frontend. If you are changing this file, please also make the
 * corresponding changes in: `functions/src/translation/translationDocumentInterfaces.ts`
 *
 * Be careful because import paths may be different. Don't forget to double
 * check that you update the comments in `functions` as well.
 * =============================================================================
 */

import {CourseId} from 'types/common';
import {LanguageCode, NamespaceId} from '../../components/translation/utils';

/** ============== COPY EVERYTHING STARTING HERE TO functions ============= */

/**
 * Maps a translation key to a translation. In the database, this map is stored
 * in the `translations` field of the document.
 */
export type TranslationNamespaceDocument = Record<string, string>;

/**
 * Metadata about translations available to the course.
 */
export interface CourseTranslationDocument {
  /** The set of languages that material is translated into for the course. */
  supportedLanguages: LanguageCode[];
}

export const getTranslationCollectionPath = ({
  courseId,
  language,
}: {
  courseId: CourseId;
  language: LanguageCode;
}) => {
  return `translation/${courseId}/${language}`;
};

export const getTranslationDocumentPath = ({
  courseId,
  language,
  namespace,
}: {
  courseId: CourseId;
  language: LanguageCode;
  namespace: NamespaceId;
}) => {
  return `${getTranslationCollectionPath({courseId, language})}/${namespace}`;
};

export const getCourseTranslationDocumentPath = ({
  courseId,
}: {
  courseId: CourseId;
}) => {
  return `translation/${courseId}`;
};
